export default __webpack_public_path__ + "static/media/gr20-2018-complete-northsouth.8025a3a8.gpx";